import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppWrapper from '../components/AppWrapper';

const AppRouter: React.FC = () => {
  return (
    <BrowserRouter>
      <AppWrapper />
    </BrowserRouter>
  );
};

export default AppRouter;
